<template>
  <v-main>
    <div class="pa-5">
      <AppHeader />
      <router-view />
    </div>
  </v-main>
</template>

<script>
import AppHeader from "@/components/Layouts/Sections/MainHeaderLayout";

export default {
  name: "MainLayout",
  components: {
    AppHeader,
  },
};
</script>
